import { logger } from '@sendpayments/js-utils';

export const reduce = (state, action) => {
  const { payload } = action;
  const { key, initialState, ex } = payload || {};

  if (!payload) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/ERROR_IN_REMOTE_DATA. payload need to be passed`, action);
  }

  if (!key) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/ERROR_IN_REMOTE_DATA. key need to be passed`, action);
  }

  if (!initialState) {
    logger.error(
      '@sendpayments/react-shared/remote-data',
      `reducer/ERROR_IN_REMOTE_DATA. initialState need to be passed`,
      action,
    );
  }

  const currentRemoteData = state[key];
  if (!currentRemoteData) {
    logger.error(
      '@sendpayments/react-shared/remote-data',
      `reducer/ERROR_IN_REMOTE_DATA. ${key} need to be initialized first.`,
      action,
    );
  }

  logger.log('@sendpayments/react-shared/remote-data', `reducer/ERROR_IN_REMOTE_DATA. ${key} has an error`, action);

  const prevState = state[key] || {};

  return {
    ...state,
    [key]: {
      loading: false,
      // maybe set last valid state
      data: initialState,
      failed: true,
      ex,
      exceptionsHistory: [...((currentRemoteData || {}).exceptionsHistory || []), ex],
      initialized: true,
      invalidate: false,
      lastUpdated: +new Date(),
      fetching: false,
      offline: false,
      fetched: prevState.fetched,
    },
  };
};
